import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=1807db85&scoped=true&"
import script from "./NewMessage.vue?vue&type=script&lang=js&"
export * from "./NewMessage.vue?vue&type=script&lang=js&"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=1807db85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807db85",
  null
  
)

export default component.exports